import { Modal } from 'antd';

import { useSharedState } from '../../../hooks/use-shared-state';
import { useRemoveDashboard } from '../dashboard-queries';
import { DashboardRemove, dashboardListState } from '../models/dashboard-list';

export function DashboardRemoveDialog({ model }: { model: DashboardRemove }) {
  const removeDashboard = useRemoveDashboard();

  const [, setDashboardList] = useSharedState(dashboardListState);
  const onOk = async () => {
    const res = await removeDashboard.mutateAsync(model);
    if (!res?.ok) {
      // keep the dialog open, the error notification is raised by the mutation.
      return;
    }

    setDashboardList({ ...dashboardListState.get(), remove: undefined });
  };
  const onCancel = () => {
    // updates model.create to undefined to close modal.
    setDashboardList({ ...dashboardListState.get(), remove: undefined });
  };

  return (
    <Modal
      title="Remove Dashboard?"
      maskClosable={false}
      open
      onOk={onOk}
      onCancel={onCancel}
      okButtonProps={{ disabled: removeDashboard.isPending }}
      cancelButtonProps={{ disabled: removeDashboard.isPending }}
      data-testid="remove-dashboard-modal"
    >
      Are you sure you want to remove the selected dashboard?
    </Modal>
  );
}
